export default __webpack_public_path__ + "static/media/join-cashback-img.35c15198.svg";